import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react";
import { useStaticQuery } from "gatsby";
import { useStatePersist } from "use-state-persist";
import Header from "./header";
import Footer from "./footer";
import Cookies from "./cookies";
import SEO from "../components/seo"; //import "./base.css"
//import "./bootstrap.min.css"

import "./addon.min.css";
import "./vf-addon.css";
import "./theme.css";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { useCookies } from "react-cookie";
import { useStateWithSessionStorage, createSignalsSession } from "./analytics";
import { v4 as uuidv4 } from "uuid";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Layout = function Layout(props) {
  var _useCookies = useCookies(["ap-signals-user-id"]),
      cookies = _useCookies[0],
      setCookie = _useCookies[1];

  var _useStateWithSessionS = useStateWithSessionStorage("ap-signals-session-id"),
      sessionIDValue = _useStateWithSessionS[0],
      setSessionIDValue = _useStateWithSessionS[1];

  var _useStateWithSessionS2 = useStateWithSessionStorage("ap-signals-session-fingerprint"),
      fingerPrintResult = _useStateWithSessionS2[0],
      setFingerPrintResult = _useStateWithSessionS2[1];

  useEffect(function () {
    ;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fp, result, visitorId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (cookies["ap-signals-user-id"]) {
                _context.next = 12;
                break;
              }

              _context.next = 3;
              return FingerprintJS.load();

            case 3:
              fp = _context.sent;
              _context.next = 6;
              return fp.get();

            case 6:
              result = _context.sent; // This is the visitor identifier:

              visitorId = result.visitorId;
              setCookie("ap-signals-user-id", visitorId);
              setFingerPrintResult(JSON.stringify(result));
              _context.next = 13;
              break;

            case 12:
              if (!sessionIDValue) {
                setSessionIDValue("" + uuidv4());
              }

            case 13:
              createSignalsSession(cookies["ap-signals-user-id"], sessionIDValue, props.siteConfig, props.location, fingerPrintResult);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [cookies["ap-signals-user-id"], sessionIDValue]);
  var siteConfig = props.siteConfig || {};

  var _useStatePersist = useStatePersist("@fontSize", "normal"),
      fontSize = _useStatePersist[0],
      setFontSize = _useStatePersist[1];

  var _useStatePersist2 = useStatePersist("@colourContrast", false),
      colourContrast = _useStatePersist2[0],
      setColourContrast = _useStatePersist2[1];

  var iFrameView = false;
  var HideCareersLink = false;

  if (props.location && props.location.search) {
    var searchParams = new URLSearchParams(props.location.search);
    var entries = searchParams.entries();

    for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
      var pair = _step.value;

      if (pair[0] === "iframe") {
        iFrameView = pair[1];
      }

      if (pair[0] === "HideCareersLink") {
        HideCareersLink = pair[1];
      }
    }
  }

  var data = useStaticQuery("3649515864");
  return /*#__PURE__*/_jsxs("div", {
    className: "main-app-wrap colour-contrast-" + colourContrast + " font-size-" + fontSize + " iframe-view-" + iFrameView + " hide-careers-link-" + HideCareersLink,
    children: [/*#__PURE__*/_jsx(SEO, {
      siteConfig: props.siteConfig,
      apiKey: props.apiKey,
      groupOrIdParam: props.groupOrIdParam,
      smartfeedCompanyData: props.smartfeedCompanyData,
      vacanciesRouteLoading: props.vacanciesRouteLoading,
      vacanciesRouteError: props.vacanciesRouteError,
      title: props.title,
      description: props.description
    }), /*#__PURE__*/_jsx(Header, {
      location: props.location,
      siteConfig: props.siteConfig || {},
      vacanciesRouteError: props.vacanciesRouteError,
      vacanciesRouteLoading: props.vacanciesRouteLoading,
      apiKey: siteConfig.apiKey || props.apiKey,
      groupOrIdParam: props.groupOrIdParam,
      smartfeedCompanyData: siteConfig.smartfeedCompanyData || props.smartfeedCompanyData,
      appGatewayURL: props.appGatewayURL,
      siteTitle: data.site.siteMetadata.title,
      setFontSize: setFontSize,
      colourContrast: colourContrast,
      setColourContrast: setColourContrast,
      trackEvent: props.trackEvent,
      alwaysDisplayHeader: props.alwaysDisplayHeader
    }), /*#__PURE__*/_jsx("div", {
      className: "app-layout",
      children: /*#__PURE__*/_jsx("main", {
        id: "main",
        children: props.children
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "footer-layout",
      children: [/*#__PURE__*/_jsx(Footer, {
        displayJACTA: props.displayJACTA || true,
        siteConfig: props.siteConfig || {},
        vacanciesRouteError: props.vacanciesRouteError,
        vacanciesRouteLoading: props.vacanciesRouteLoading,
        apiKey: siteConfig.apiKey || props.apiKey,
        groupOrIdParam: props.groupOrIdParam,
        smartfeedCompanyData: siteConfig.smartfeedCompanyData || props.smartfeedCompanyData,
        appGatewayURL: props.appGatewayURL,
        setFontSize: setFontSize,
        colourContrast: colourContrast,
        setColourContrast: setColourContrast,
        jobAlertsPage: props.jobAlertsPage,
        trackEvent: props.trackEvent
      }), /*#__PURE__*/_jsx(Cookies, {
        siteConfig: props.siteConfig || {},
        vacanciesRouteError: props.vacanciesRouteError,
        vacanciesRouteLoading: props.vacanciesRouteLoading,
        apiKey: siteConfig.apiKey || props.apiKey,
        groupOrIdParam: props.groupOrIdParam,
        smartfeedCompanyData: siteConfig.smartfeedCompanyData || props.smartfeedCompanyData,
        trackEvent: props.trackEvent
      })]
    })]
  });
};

export default Layout;